import moment from 'moment';
import nuPointSprayApi from '@/api/nuPointSprayApi';
import locationApi from '@/api/locationApi';

export default  {
    namespaced: true,
    state: {
        selectedFromDate: moment().add(-1, 'month').format('YYYY-MM-DD'),
        selectedToDate: '',
        selectedPlantIDs: [],
        loadingPlants: false,
        loadingLocations: false,
        loadingJobs: false,
        plantData: [],
        locations: [],
        nuPointSprayJobs: [],
        error: null    
    },
    mutations: {
        setSelectedPlantIDs(state, selectedPlantIDs){
            state.selectedPlantIDs = selectedPlantIDs;
        },
        setSelectedFromDate(state, selectedDate) {
            state.selectedFromDate = selectedDate;
        },
        setSelectedToDate(state, selectedDate) {
            state.selectedToDate = selectedDate;
        }
    },
    actions: {
        async loadPlants({ state }){
            state.loadingPlants = true;
            state.error = null;
            let plantData = [];

            try {
                plantData = await nuPointSprayApi.getPlantData();
                if(plantData == null){
                    plantData = [];
                }
            } catch(e) {                
                state.error = e.toString();
            }

            state.plantData = plantData;
            state.loadingPlants = false;
        },
        async loadLocations({ state }){
            state.loadingLocations = true;
            state.error = null;
            let locations = [];

            try {
                locations = await locationApi.getLocations();
                if(locations == null){
                    locations = [];
                }
            } catch(e) {                
                state.error = e.toString();
            }

            state.locations = locations;
            state.loadingLocations = false;
        },
        async searchNuPointSprayJobs({ state }){
            state.loadingJobs = true;
            state.error = null;
            let nuPointSprayJobs = [];

            try {
                nuPointSprayJobs = await nuPointSprayApi.searchNuPointSprayJobs(state.selectedPlantIDs, state.selectedFromDate, state.selectedToDate);
                if(nuPointSprayJobs == null){
                    nuPointSprayJobs = [];
                }
            } catch(e) {                
                state.error = e.toString();
            }

            state.nuPointSprayJobs = nuPointSprayJobs;
            state.loadingJobs = false;
        }
    }
}